export const EVENTS = {
  sortSelected: 'sort:selected',
  variantChange: 'variant:change',
  ajaxProductError: 'ajaxProduct:error',
  ajaxProductAdded: 'ajaxProduct:added',
  mobileNavOpen: 'mobileNav:open',
  mobileNavClose: 'mobileNav:close',
  predictiveSearchOpen: 'predictiveSearch:open',
  predictiveSearchClose: 'predictiveSearch:close',
  predictiveSearchCloseAll: 'predictiveSearch:close-all',
  headerStickyCheck: 'headerSticky:check',
  overlayHeaderChange: 'overlayHeader:change',
  headerOverlayDisable: 'headerOverlay:disable',
  headerOverlayRemoveClass: 'headerOverlay:remove-class',
  cartDrawerChange: 'CartDrawer:change',
  youtubeReady: 'youtube:ready',
  vimeoReady: 'vimeo:ready',
  cartOpen: 'cart:open',
  cartClose: 'cart:close',
  sizeDrawer: 'size:drawer',
  cartUpdated: 'cart:updated',
  headerDrawerOpened: 'headerDrawer:opened',
  headerDrawerClosed: 'headerDrawer:closed',
  headerSearchOpen: 'headerSearch:open',
  headerSearchClose: 'headerSearch:close',
  toggleMobileFilters: 'toggleMobileFilters'
}
